<template>
  <AddUser />
</template>

<script>
import AddUser from '../../../components/user/AddUserList.vue'
export default {
  components: {
    AddUser,
  },
}
</script>

<style scoped lang="scss">
</style>